import styled from 'styled-components';
import { Input } from 'components/elements';

export const Blik = styled.div`
	position: relative;
	width: ${({ tiny }) => (tiny ? '17rem' : 'auto')};
	font-size: 1.4rem;
`;

export const StyledInput = styled(Input)`
	padding: ${({ tiny }) => (tiny ? '0.8rem 1.4rem' : '1.6rem 1.4rem')};
	border: 1px solid ${({ theme }) => theme.graySoft};
	border-radius: 4px;
`;

export const FormError = styled.div`
	width: 100%;
	position: absolute;
	bottom: ${({ tiny }) => (tiny ? -2 : -2.5)}rem;
	font-size: ${({ tiny }) => (tiny ? 1 : 1.2)}rem;
	color: ${({ theme }) => theme.red};
	margin: 0 !important;
`;
